import React from "react";
import { MainScreen } from "../main-screen/main-screen";
import { InfoUnit } from "../info-unit/info-unit";
import { InfoUnitMobiles } from "../info-unit/info-unit-mobiles";
import "../../constructor/common.css";
import { FeatureBlock } from "../feature-block/feature-block";
import { AboutBlockV2 } from "../about-block/about-block-v2";
import { Footer } from "../../footer/footer";
import { FeatureCard } from "../feature-block/feature-card";

export const ExamplePage = () => {
	return (
		<>
			<MainScreen
				backgroundColor="radial-gradient(127.41% 100.78% at 50% 65.06%, rgba(179, 130, 255, 0.20) 24.5%, rgba(113, 46, 217, 0.20) 38.5%, rgba(26, 8, 53, 0.20) 53.79%), #0A0A0A"
				titleColor="#FFF"
				textColor="#FFF"
				isHeaderOnLight
			/>

			<AboutBlockV2 />

			<FeatureBlock
				backgroundColor="#1F1F1F"
				title="Проектирование и дизайн"
				textColor="#FFF"
			>
				<InfoUnit
					title="Общее про дизайн"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					textColor="#FFF"
					picture="/img/d1.png"
					picture2="/img/d1.png"
				/>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#8C61E6"
				textColor="#FFF"
				borderRadius={48}
			>
				<InfoUnit
					title="Особенность 2"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					textColor="#FFF"
					picture="/img/screen.png"
				/>
			</FeatureBlock>

			<FeatureBlock>
				<InfoUnit
					title="Особенность 3"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
				/>
				<InfoUnit
					title="Особенность 4"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					picture="/img/odin.png"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#1F1F1F" textColor="#FFF">
				<InfoUnitMobiles
					title="Особенность 5"
					textColor="#FFF"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					picture="/img/m1.png"
					picture2="/img/m2.png"
					picture3="/img/m3.png"
					picture4="/img/m4.png"
				/>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#8C61E6"
				textColor="#FFF"
				borderRadius={48}
			>
				<InfoUnit
					title="Особенность 6"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					textColor="#FFF"
					picture="/img/info.png"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#ECF2F7" title="Возможности продукта">
				<InfoUnit
					title="Особенность 5"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
						"Lorem commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum",
						"Lorem ipsum soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat",
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et olestias in natus unde ut facilis voluptates",
						"Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla ",
					]}
				/>
			</FeatureBlock>

			<FeatureBlock title={"Возможности продукта"} cards>
				<FeatureCard
					text={
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores."
					}
					title={"Особенность 3"}
					picture={"/img/iphone.png"}
				/>
				<FeatureCard
					text={
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores."
					}
					title={"Особенность 4"}
					picture={"/img/iphone2.png"}
					backgroundColor="#E6AE1C"
				/>
				<FeatureCard
					text={
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores."
					}
					title={"Особенность 4"}
					picture={"/img/iphone2.png"}
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#1F1F1F" textColor="#FFF">
				<InfoUnitMobiles
					variant="system"
					title="Дизайн система"
					textColor="#FFF"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					picture="/img/s1.png"
					picture2="/img/s2.png"
					picture3="/img/s3.png"
					picture4="/img/s4.png"
					picture5="/img/s5.png"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#1F1F1F" textColor="#FFF">
				<InfoUnitMobiles
					variant="grid"
					title="Особенность 1"
					textColor="#FFF"
					text={[
						"Lorem ipsum dolor sit amet. Qui commodi nostrum eos soluta consequatur et ipsam assumenda et nobis nostrum ex voluptates voluptatem ut dolorum asperiores. Non praesentium nulla rem autem placeat et consequuntur molestias in natus unde ut facilis voluptates",
					]}
					picture="/img/m1.png"
					picture2="/img/m2.png"
					picture3="/img/m4.png"
					picture5="/img/m4.png"
					picture6="/img/m1.png"
					picture8="/img/m3.png"
				/>
			</FeatureBlock>

			<Footer backgroundColor="rgb(31, 31, 31)" />
		</>
	);
};
